<div class="text-center">
  <h1 class="mb-8 text-3xl font-semibold leading-normal">
    Setup Authenticator App
  </h1>
  <p>Scan the QR code with your 2FA app</p>
  <canvas #totpQRCanvas class="mx-auto my-6"></canvas>
  <p class="mb-2">Or enter the key below into your 2FA app:</p>
  <p class="text-base-content/70">{{ totpInfo?.secret?.secretKey }}</p>
  <div>
    <app-auth-code-input
      [(code)]="totpCode"
      (enter)="verifyCode.emit(totpCode)"
    ></app-auth-code-input>
    <button
      class="btn btn-primary mb-6 w-full"
      (click)="verifyCode.emit(totpCode)"
      [disabled]="verifyingTOTP"
    >
      Verify Authentication Code
    </button>
    <button
      class="btn btn-secondary mb-6 w-full"
      (click)="goBack.emit()"
      [disabled]="verifyingTOTP"
    >
      Back
    </button>
  </div>
</div>
